const FrequencyType = {
    NEVER: 'NEVER',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY'
};

module.exports = Object.freeze(FrequencyType);